import React, { useEffect, useState } from "react";
import { Row, Col, Modal, Button } from "react-bootstrap";
import success from "../../../Assets/Images/check.png";
// ... other imports

function SuccessModal({ showModal, modalMessage, setShowModal }) {
  // ... existing code

  const handleCloseModal = () => setShowModal(false);

  return (
    <>
      <Modal
        style={{ left: "5%" }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showModal}
        onHide={handleCloseModal}
      >
        <Modal.Body align="center">
          <img src={success} alt="" style={{ height: "50px", width: "50px" }} />
          <br />
          <h4 style={{ color: "green" }}>Success!</h4>
          <h5 className="mt-4">{modalMessage}</h5>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SuccessModal;
